<div class="modal-overlay" *ngIf="visible">
    <div class="modal-content">
        <div class="modal-header">
            <h4>Sessão Expirando</h4>
        </div>

        <div class="modal-body">
            <p>Sua sessão irá expirar em {{segundosRestantes}} segundo{{segundosRestantes !== 1 ? 's' : ''}}.</p>
            <p>Deseja renovar sua sessão?</p>

            <div class="progress-bar-container">
                <div class="progress-bar" [style.width.%]="progressValue"></div>
            </div>
        </div>

        <div class="modal-footer">
            <button class="btn-primary" (click)="renovarSessao()">Sim</button>
            <button class="btn-secondary" (click)="sair()">Não</button>
        </div>
    </div>
</div>